import * as v from 'valibot';
import { dateStringSchema } from '../../util/valibot';
import { groupSchema } from './Group';
export const groupsSchema = v.object({
    fetched_ts: dateStringSchema,
    items: v.array(groupSchema)
});
